import React from 'react';

const WhatNews = () => {
  return <div>WhatNews</div>;
};

export default WhatNews;
